//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectFace.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"CheckClearance",1,0],[1,"Clearance",0,"Expression",0],[1,"CornerRadius",0,"Expression",0],[1,"CutoutProfile",0,"Section",0],[1,"Diameter",0,"Expression",0],[1,"DieRadius",0,"Expression",0],[0,"HoleCenter",1,"Point",0],[1,"HoleFace",0,"SelectFace",0],[1,"Length",0,"Expression",0],[0,"ReverseBendDirection",1,0],[0,"StandardName",1,0],[0,"Type",1,0]],[[["numStandardNames"],"GetStandards",{R_:{standardNames:""}},0,0]],[]];
SPLM.Features.SheetMetal.AeroLighteningCutoutBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.AeroLighteningCutoutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.AeroLighteningCutoutBuilder.Types = Object.freeze({
    "Hole" : "Hole", "UserDefined" : "UserDefined"});

export default SPLM;